import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { SegmentProvider } from '../../../../providers/SegmentProvider.js'
import { BillingContent } from './BillingContent.js'
import { BillingFooter } from './BillingFooter.js'
import { BillingHeader } from './BillingHeader.js'

export const BillingPage = () => {
  return (
    <SegmentProvider>
      <Container size="lg">
        <BillingHeader />
        <BillingContent />
        <BillingFooter />
      </Container>
    </SegmentProvider>
  )
}
